(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["floating-actions"] && !Shopify.designMode) return;
  try {
    (function () {
    var root = document.querySelector('[data-floating-actions]');
    if (!root) return;
    var topBtn = root.querySelector('[data-scroll-top]');
    if (!topBtn) return;

    var SHOW_AT = 400;
    var ticking = false;
    var footer = document.querySelector('.site-footer');
    function update() {
      var y = window.pageYOffset || document.documentElement.scrollTop || 0;
      topBtn.classList.toggle('is-visible', y > SHOW_AT);
      // Soulève les stacks flottants (droite ET gauche via --fab-lift) au-dessus
      // du footer dès qu'il entre à l'écran : plus de superposition au contenu.
      if (footer) {
        var overlap = Math.max(0, window.innerHeight - footer.getBoundingClientRect().top);
        document.documentElement.style.setProperty('--fab-lift', overlap + 'px');
      }
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    window.addEventListener('resize', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    });
    update();

    topBtn.addEventListener('click', function () {
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__productCardInit) return;
    window.__productCardInit = true;

    const STORAGE_KEY = 'ad-parfumerie-wishlist';

    /* ----- Wishlist ------------------------------------------------------- */
    const readWishlist = () => {
      try {
        const list = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    };
    const writeWishlist = (list) => {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { count: list.length } }));
    };

    const refreshWishlist = () => {
      const list = readWishlist();
      document.querySelectorAll('[data-product-card][data-product-handle]').forEach((card) => {
        const handle = card.dataset.productHandle;
        const btn = card.querySelector('[data-product-card-wishlist]');
        if (!btn) return;
        const isIn = list.indexOf(handle) >= 0;
        btn.setAttribute('aria-pressed', isIn ? 'true' : 'false');
        const labelAdd = btn.getAttribute('data-label-add');
        const labelRemove = btn.getAttribute('data-label-remove');
        btn.setAttribute('aria-label', isIn ? labelRemove : labelAdd);
      });
    };

    document.addEventListener('click', (event) => {
      const btn = event.target.closest('[data-product-card-wishlist]');
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      const card = btn.closest('[data-product-card]');
      if (!card) return;
      const handle = card.dataset.productHandle;
      if (!handle) return;
      const list = readWishlist();
      const idx = list.indexOf(handle);
      if (idx >= 0) list.splice(idx, 1); else list.push(handle);
      writeWishlist(list);
      refreshWishlist();
    });
    refreshWishlist();
    window.addEventListener('wishlist-updated', refreshWishlist);
    window.addEventListener('storage', (e) => {
      if (e.key === STORAGE_KEY) refreshWishlist();
    });

    /* ----- Quick add: popover toggle ------------------------------------- */
    const closeAllPopovers = (except) => {
      document.querySelectorAll('[data-pc-popover]').forEach((p) => {
        if (p === except) return;
        p.hidden = true;
        const trigger = document.querySelector('[aria-controls="' + p.id + '"]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    };

    const positionPopover = (popover, toggle) => {
      // Anchor under the toggle button. Popover is position:fixed so it
      // escapes any ancestor overflow:hidden / clip context (carousel track).
      const r = toggle.getBoundingClientRect();
      const margin = 8;
      const vw = window.innerWidth;
      const popWidth = popover.offsetWidth || 240;
      let left = r.left + (r.width / 2) - (popWidth / 2);
      left = Math.max(margin, Math.min(left, vw - popWidth - margin));
      const top = r.bottom + 10;
      popover.style.left = left + 'px';
      popover.style.top = top + 'px';
      popover.style.right = 'auto';
      popover.style.bottom = 'auto';
    };

    // Move popovers to <body> once on init so they escape carousel scroll containers.
    document.querySelectorAll('[data-pc-popover]').forEach((p) => {
      if (p.parentElement && p.parentElement !== document.body) {
        document.body.appendChild(p);
      }
    });

    document.addEventListener('click', (event) => {
      const toggle = event.target.closest('[data-pc-quick-add-toggle]');
      if (toggle) {
        event.preventDefault();
        const popoverId = toggle.getAttribute('aria-controls');
        const popover = popoverId ? document.getElementById(popoverId) : null;
        if (!popover) return;
        const isOpen = !popover.hidden;
        closeAllPopovers(isOpen ? null : popover);
        if (isOpen) {
          popover.hidden = true;
        } else {
          popover.hidden = false;
          positionPopover(popover, toggle);
        }
        toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        return;
      }
      // outside click closes
      if (!event.target.closest('[data-pc-popover]') && !event.target.closest('[data-pc-quick-add-toggle]')) {
        closeAllPopovers();
      }
    });

    // Keep popover anchored on scroll/resize while open.
    const repositionOpen = () => {
      document.querySelectorAll('[data-pc-popover]:not([hidden])').forEach((p) => {
        const trigger = document.querySelector('[aria-controls="' + p.id + '"]');
        if (trigger) positionPopover(p, trigger);
      });
    };
    window.addEventListener('scroll', repositionOpen, { passive: true });
    window.addEventListener('resize', repositionOpen);

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllPopovers();
    });

    /* ----- Quick add: AJAX cart submission ------------------------------- */
    const addToCart = async (variantId, button) => {
      if (!variantId || !button) return;
      if (button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: parseInt(variantId, 10), quantity: 1 }],
            sections: ['cart-drawer'],
          }),
        });
        const data = await response.json();
        if (!response.ok) {
          alert((data && data.description) || button.getAttribute('data-error-add') || "Erreur lors de l'ajout au panier.");
          return;
        }

        const drawerHtml = data.sections && data.sections['cart-drawer'];
        if (drawerHtml && typeof window.cartDrawerReplace === 'function') {
          window.cartDrawerReplace(drawerHtml, true);
          if (typeof window.cartDrawerRefreshCount === 'function') window.cartDrawerRefreshCount();
          window.dispatchEvent(new CustomEvent('cart-updated'));
        } else if (typeof window.cartDrawerOpen === 'function') {
          window.cartDrawerOpen();
          if (typeof window.cartDrawerRefreshCount === 'function') window.cartDrawerRefreshCount();
          window.dispatchEvent(new CustomEvent('cart-updated'));
        } else {
          window.location.reload();
        }
      } catch (err) {
        console.error('[product-card] add to cart failed', err);
        alert(button.getAttribute('data-error-unavailable') || "Impossible d'ajouter au panier. Réessayez.");
      } finally {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        closeAllPopovers();
      }
    };

    document.addEventListener('click', (event) => {
      const fast = event.target.closest('[data-pc-fast-add]');
      if (!fast) return;
      event.preventDefault();
      addToCart(fast.dataset.variantId, fast);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-pc-form]');
      if (!form) return;
      event.preventDefault();
      const fd = new FormData(form);
      const variantId = fd.get('id');
      const submit = form.querySelector('button[type="submit"]');
      addToCart(variantId, submit);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["qty-selector"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__qtySelectorInit) return;
    window.__qtySelectorInit = true;

    const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

    const sync = (input) => {
      const root = input.closest('[data-qty-selector]');
      if (!root) return;
      const min = parseInt(input.min || '1', 10);
      const max = parseInt(input.max || '10', 10);
      const value = parseInt(input.value || '1', 10);
      const dec = root.querySelector('[data-qty-action="decrement"]');
      const inc = root.querySelector('[data-qty-action="increment"]');
      if (dec) dec.toggleAttribute('disabled', value <= min);
      if (inc) inc.toggleAttribute('disabled', value >= max);
    };

    const handleClick = (event) => {
      const btn = event.target.closest('[data-qty-action]');
      if (!btn) return;
      const root = btn.closest('[data-qty-selector]');
      if (!root) return;
      const input = root.querySelector('[data-qty-input]');
      if (!input) return;
      const min = parseInt(input.min || '1', 10);
      const max = parseInt(input.max || '10', 10);
      const cur = parseInt(input.value || '1', 10);
      const next = btn.dataset.qtyAction === 'increment' ? cur + 1 : cur - 1;
      const clamped = clamp(next, min, max);
      if (clamped === cur) return;
      input.value = String(clamped);
      sync(input);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      input.dispatchEvent(new Event('input', { bubbles: true }));
    };

    const handleInput = (event) => {
      const input = event.target.closest('[data-qty-input]');
      if (!input) return;
      const min = parseInt(input.min || '1', 10);
      const max = parseInt(input.max || '10', 10);
      const raw = parseInt(input.value, 10);
      const clamped = isNaN(raw) ? min : clamp(raw, min, max);
      if (String(clamped) !== input.value) {
        input.value = String(clamped);
      }
      sync(input);
    };

    document.addEventListener('click', handleClick);
    document.addEventListener('change', handleInput);
    document.querySelectorAll('[data-qty-input]').forEach(sync);
  })();
  } catch(e) { console.error(e); }
})();

})();
